import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
    errorContainer: {
        marginBottom: '45px',
        width: '100%',
        padding: '34px 35px',
        '@media(max-width: 768px)': {
            padding: 30,
        },
        '@media(max-width: 480px)': {
            padding: 20,
        }
    },
    header: {
    },
    errorSection: {
        padding: '110px 90px',
        backgroundColor: '#ffffff',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        // height: '100%',
        justifyContent: 'center',
        marginTop: '24px',
        marginBottom: '30px',
        maxWidth: '870px',
        width: '100%',
        textAlign: 'center',
        boxSizing: 'border-box',
        '@media(max-width: 768px)': {
            padding: '15% 10%',
        },
    },
    errorHeader: {
        marginBottom: 20,
        fontSize: 26,
        '@media(max-width: 480px)': {
            marginBottom: 20,
            fontSize: 20,
        },
    },
    errorLabel: {
        maxWidth: 400,
        margin: '0 auto 35px'
    },
    mainImage: {
        width: '212px',
        height: '200px',

    },
    bodyContent: {
    },
    buttonsRow: {
        // margin: '50px 0 0',
        maxWidth: 870,
        display: 'flex',
        justifyContent: 'center',
        '@media(max-width: 768px)': {
            display: 'block',
        },
        '& .MuiButton-root': {
            padding: '6px 24px',
            minWidth: 'auto'
        },
        '& .MuiButton-contained': {
            marginLeft: '30px',
            '@media(max-width: 768px)': {
                width: '100%',
                marginLeft: '0'
            },
        },
        '& .MuiButton-outlined': {
            '@media(max-width: 768px)': {
                width: '100%',
                marginBottom: 10
            },
        }
    },
    link: {
        color: "#2d91e9",
        textDecoration: "none",
        fontFamily: "CircularStd",
        fontSize: 16,
      }
});
